import { CanActivateFn } from '@angular/router';
import { createIdentityGuard } from './guard-factories';

export const externalUserAuthGuard: CanActivateFn = createIdentityGuard(
  authService => authService.getIsAuthedExternalUduUser()
);
